import * as React from "react"

import { Modal } from "@tenforce/toolbox-modal-react"
import { PreviewFeature } from "./PreviewFeature"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { useAppDispatch } from "../../../hooks"
import { updatePreviewFeatureDisplay } from "../slice"
import { Labels } from "../../../util/Translations"
import { IPreviewFeature } from "../index"

export type Props = {
    features: IPreviewFeature[]
    isLoading?: boolean
}

export const PreviewFeaturesFooterItem = (props: Props): JSX.Element => {
    const { features } = props
    const [isShown, setIsShown] = React.useState(false)
    const currentPreviewFeatures = React.useRef<Map<number, boolean> | null>()
    const dispatch = useAppDispatch()

    const handleOnChanged = (id: number, newValue: boolean): void => {
        if (!currentPreviewFeatures.current) {
            currentPreviewFeatures.current = new Map()
        }
        currentPreviewFeatures.current.set(id, newValue)
    }

    const handleCancel = (): void => {
        setIsShown(false)
    }

    const handleApply = async (): Promise<void> => {
        await dispatch(
            updatePreviewFeatureDisplay({
                features,
                currentPreviewFeatures:
                    currentPreviewFeatures?.current || new Map(),
            }),
        )
        setIsShown(false)
    }

    const previewFeatures = features?.map((feature) => {
        return (
            <PreviewFeature
                key={feature.id}
                {...feature}
                onEnabledChanged={handleOnChanged}
            />
        )
    })

    const {
        RefreshToApplyChange,
        Cancel,
        BetaFeaturesButton,
        BetaFeaturesLabel,
    } = Labels
    return (
        <>
            <Action
                id="NewUI__previewFeaturesButton"
                extraClasses="text-default"
                isLabel={true}
                onClick={(): void => setIsShown(true)}
            >
                {Symbols.WorkspaceGridSettings}{" "}
                {BetaFeaturesButton || "Early access"}
            </Action>

            <Modal
                isShown={isShown}
                containerProps={{
                    id: "previewFeaturesModal",
                    onClose: () => setIsShown(false),
                    isCenterFixedPositioned: true,
                }}
                contentProps={{
                    extraClasses: "bg-default tw-mx-1/5",
                }}
            >
                <div className="tw-flex tw-justify-between">
                    <header className="step-header">
                        <h3 className="tw-mt-2 tw-mb-3">
                            {BetaFeaturesLabel || "Early access Features"}
                        </h3>
                    </header>
                </div>

                {previewFeatures}

                <div className="separator-line is-dotted is-dimmed"></div>
                <div className="tw-flex tw-items-center tw-py-4 tw-px-6">
                    <Action
                        data-testid="preview-features-footer-item-reload"
                        actionType={ActionType.button}
                        extraClasses="tw-flex-1"
                        isTransparent={false}
                        onClick={handleApply}
                        isLoading={props.isLoading}
                    >
                        {RefreshToApplyChange ||
                            "Reload this page to apply the changes"}
                    </Action>
                    <Action
                        data-testid="preview-features-footer-item-cancel"
                        actionType={ActionType.button}
                        extraClasses="tw-flex-1"
                        isTransparent={true}
                        isSecondary={true}
                        onClick={handleCancel}
                        isLoading={props.isLoading}
                    >
                        {Cancel || "Cancel"}
                    </Action>
                </div>
            </Modal>
        </>
    )
}
